import React from 'react'

export const Container2Home = () => {
  return (
    <div className="Container2Home">
        <div className="ContainerTextHome">
            <h2>Consigue aun mas seguidores y vistas obteniendo nuestros planes</h2>
            <p>Te ofrecemos diferentes planes que te pueden ayudar a tener mayor exposición de tu marca, ¿Que esperas para obtenerlos?</p>
        </div>
        <div className="ContainerImghome">
            <div className="imageBack"></div>
        </div>
    </div>
  )
}
